import e from "./Breadcrumb.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, s, r, a, i, l) {
  var u = ("function" == typeof n ? n.options : n) || {};
  return u.__file = "Breadcrumb.vue", u.render || (u.render = e.render, u.staticRenderFns = e.staticRenderFns, u._compiled = !0, r && (u.functional = !0)), u._scopeId = s, u;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: [e.suit(), !e.state.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", function () {
      return [n("ul", {
        class: e.suit("list")
      }, [n("li", {
        class: [e.suit("item"), !e.state.items.length && e.suit("item", "selected")]
      }, [Boolean(e.state.items.length) ? n("a", {
        class: e.suit("link"),
        attrs: {
          href: e.state.createURL()
        },
        on: {
          click: function click(t) {
            return t.preventDefault(), e.state.refine();
          }
        }
      }, [e._t("rootLabel", function () {
        return [e._v("Home")];
      })], 2) : n("a", {
        class: e.suit("link"),
        attrs: {
          href: e.state.createURL(null)
        },
        on: {
          click: function click(t) {
            return t.preventDefault(), e.state.refine(null);
          }
        }
      }, [e._t("rootLabel", function () {
        return [e._v("Home")];
      })], 2)]), e._v(" "), e._l(e.state.items, function (t, s) {
        return n("li", {
          key: t.label,
          class: [e.suit("item"), e.isLastItem(s) && e.suit("item", "selected")]
        }, [n("span", {
          class: e.suit("separator"),
          attrs: {
            "aria-hidden": "true"
          }
        }, [e._t("separator", function () {
          return [e._v(">")];
        })], 2), e.isLastItem(s) ? [e._v(e._s(t.label))] : n("a", {
          class: e.suit("link"),
          attrs: {
            href: e.state.createURL(t.value)
          },
          on: {
            click: function click(n) {
              return n.preventDefault(), e.state.refine(t.value);
            }
          }
        }, [e._v(e._s(t.label))])], 2);
      })], 2)];
    }, {
      items: e.state.items,
      canRefine: e.state.canRefine,
      refine: e.state.refine,
      createURL: e.state.createURL
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);